const staticpage = [{
  path: '/static-zhihui',
  name: 'static',
  component: () => import( /* webpackChunkName: "openvip" */ '@/pages/static/zhihui.vue'),
  meta: {
    login: false,
    title: '袋鼠健康',
  }
}]

export default staticpage
